import { Hub } from "../@types/hub";

/**
 * Получаем объект текущего хаба
 */
export const useHub = (): Hub | undefined => {
  return global.window?.APP?.hub;
};
